import React, { createContext, useState, useContext, useEffect } from 'react';

const ScoreContext = createContext();

export const useScore = () => useContext(ScoreContext);

export const ScoreProvider = ({ children }) => {
  const [scores, setScores] = useState({});

  // localStorage-დან ჩატვირთვა
  useEffect(() => {
    const saved = localStorage.getItem('gameScores');
    if (saved) {
      try {
        setScores(JSON.parse(saved));
      } catch (e) {
        console.error('Error loading scores:', e);
      }
    }
  }, []);

  // ქულის განახლება
  const updateScore = (gameId, newScore) => {
    setScores(prev => {
      const current = prev[gameId] || 0;
      const updated = {
        ...prev,
        [gameId]: Math.max(current, newScore)
      };
      localStorage.setItem('gameScores', JSON.stringify(updated));
      return updated;
    });
  };

  // ქულის წაკითხვა
  const getScore = (gameId) => {
    return scores[gameId] || 0;
  };

  // ყველა ქულის წაშლა
  const resetScores = () => {
    setScores({});
    localStorage.removeItem('gameScores');
  };

  return (
    <ScoreContext.Provider value={{ scores, updateScore, getScore, resetScores }}>
      {children}
    </ScoreContext.Provider>
  );
};